<template>
    <div>
        <filter-sidebar-layout
            :filter-key="'filter-sidebar-tyre-moto'"
            :loading="loading"
            :fields="getFields"
            :disabled-values="disabledValues"
            v-on:change="filterValues()"
            v-on:submit="updateProductList"/>
    </div>
</template>

<script>
    import FilterSidebarLayout from "./FilterSidebarLayout";
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
    name: "TheFilterSidebarTyreMoto",
    components: {FilterSidebarLayout},
    computed: {
      ...mapState('sidebarMotoTyreModule', {
        paramInfo: 'paramInfo',
        loading: 'loading',
      }),
      ...mapGetters('sidebarMotoTyreModule', {
        isCurrentPossible: 'isCurrentPossible',
        getFields: 'getFields',
        disabledValues: 'getDisabledValues'
      }),
    },
    methods: {
      ...mapActions('sidebarMotoTyreModule', {
        filterValues: 'filterValues',
        updateProductList: 'updateProductList',
      }),
    }
  }
</script>